import React, { FC, MouseEvent } from "react";
import { ServiceFeeSubscriptionCTA } from "@modules/ServiceFees/Components/ServiceFeeSubscriptionCTA/ServiceFeeSubscriptionCTA";
import { Box } from "@UI/Components/Box/Box";
import { ServiceOfferDescription } from "../ServiceOfferDescription/ServiceOfferDescription";
import { CardProps } from "@UI/Components/Card/Card";

interface Props extends CardProps {
  serviceOfferId: number | string;
  handleServiceFeeCTAClick?: (e: MouseEvent) => void;
  showServiceFeeCTA?: boolean;
  colorScheme?: "white" | "sand";
}

export const ServiceOfferPreview: FC<Props> = ({
  serviceOfferId,
  handleServiceFeeCTAClick,
  showServiceFeeCTA,
  colorScheme,
  ...props
}) => {
  return (
    <>
      <ServiceOfferDescription
        {...props}
        serviceOfferId={serviceOfferId}
        colorScheme={colorScheme}
      />
      {showServiceFeeCTA && (
        <Box>
          <ServiceFeeSubscriptionCTA
            serviceOfferId={serviceOfferId}
            onClick={handleServiceFeeCTAClick}
          />
        </Box>
      )}
    </>
  );
};
